var _path, _rect, _rect2, _g, _rect3, _rect4, _g2, _rect5, _rect6, _rect7, _path2, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect14, _circle, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriversLicenseFrontOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3752_75218)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3752_75218)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.664 86.9775C113.664 88.2653 112.309 89.3096 110.637 89.3096L13.3584 89.3096C11.6866 89.3096 10.3312 88.2653 10.3311 86.9775L10.3311 38.5615C10.3313 36.4236 12.0641 34.6904 14.2021 34.6904L110.637 34.6904C112.309 34.6904 113.664 35.7346 113.664 37.0225L113.664 86.9775Z",
    fill: "url(#paint0_linear_3752_75218)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.2344,
    y: 52.7744,
    width: 23.5531,
    height: 23.553,
    fill: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3752_75218",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 52,
    width: 24,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2344,
    y: 52.7744,
    width: 23.5531,
    height: 23.553,
    fill: "#F9F9F9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3752_75218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.78 59.1243L22.6123 60.4731C22.2747 63.1889 24.3949 65.5865 27.1316 65.5865C27.6531 65.5865 28.171 65.6764 28.6619 65.8523C31.617 66.9109 34.7284 64.7205 34.7284 61.5815V59.9894C34.7284 59.2709 34.4954 58.5717 34.0643 57.9968L33.1832 56.8219C32.4944 55.9033 31.5875 55.1709 30.5445 54.6908C28.7486 53.8643 26.6185 54.4527 25.5017 56.084L25.2144 56.5036C23.9233 56.7618 22.9425 57.8177 22.78 59.1243Z",
    fill: "#494C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3828 82.6706V76.7684C18.3828 73.4935 20.9771 70.8071 24.25 70.6929L25.86 70.6367H30.4224L31.9003 70.6892C35.2157 70.8069 37.8832 73.454 38.0263 76.7684V82.6706L28.0966 84.5959L18.3828 82.6706Z",
    fill: "#BBC3CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9043 70.2526V68.2422C25.9043 67.9617 26.1316 67.7344 26.4121 67.7344H29.7126C29.9931 67.7344 30.2204 67.9617 30.2204 68.2422V70.2526C30.2204 70.3493 30.248 70.444 30.2999 70.5256L30.9403 71.532C31.0505 71.7053 31.1091 71.9063 31.1091 72.1117C31.1091 72.4083 30.9871 72.6918 30.7717 72.8957L30.1606 73.4745C29.048 74.5282 27.3179 74.5673 26.1589 73.5649L25.3756 72.8876C25.147 72.6899 25.0156 72.4026 25.0156 72.1003C25.0156 71.9024 25.0721 71.7086 25.1783 71.5416L25.8248 70.5256C25.8767 70.444 25.9043 70.3493 25.9043 70.2526Z",
    fill: "#A2ABB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5783 63.8426L33.2137 64.6325C33.0858 64.9098 32.8488 65.1219 32.5591 65.2185C32.3625 65.284 32.201 65.4266 32.1116 65.6136L31.4386 67.021C31.0647 67.8028 30.3979 68.4059 29.5825 68.6995L29.3654 68.7776C28.277 69.1695 27.0859 69.1695 25.9974 68.7776C25.0683 68.4431 24.3713 67.6614 24.1452 66.7001L23.7631 65.0759C23.5842 64.3156 23.5557 63.5276 23.679 62.7564L23.7579 62.2634C23.918 61.2627 24.2553 60.2985 24.7539 59.4162L25.4511 58.1826C25.5537 58.001 25.7975 57.96 25.9538 58.098L27.7272 59.6629C27.7807 59.7102 27.8436 59.7456 27.9117 59.7669L29.8395 60.3694L30.5619 60.6736C31.5969 61.1095 32.2958 62.094 32.3658 63.2149C32.3695 63.2738 32.4479 63.2915 32.4766 63.2399L32.7269 62.7893C32.8576 62.554 33.1909 62.5405 33.3402 62.7645L33.5146 63.0262C33.6763 63.2687 33.7004 63.5779 33.5783 63.8426Z",
    fill: "url(#paint1_linear_3752_75218)"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 95.9531,
    y: 62.7383,
    width: 11.7763,
    height: 11.7763,
    fill: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3752_75218",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 62,
    width: 13,
    height: 13
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 95.9531,
    y: 62.7383,
    width: 11.7763,
    height: 11.7763,
    fill: "#F9F9F9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3752_75218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.222 65.9127L99.1382 66.5871C98.9694 67.9449 100.029 69.1437 101.398 69.1437C101.659 69.1437 101.917 69.1887 102.163 69.2766C103.64 69.8059 105.196 68.7108 105.196 67.1413V66.3452C105.196 65.986 105.08 65.6364 104.864 65.3489L104.424 64.7615C104.079 64.3022 103.626 63.936 103.104 63.696C102.206 63.2827 101.141 63.5769 100.583 64.3925L100.439 64.6023C99.7936 64.7315 99.3033 65.2594 99.222 65.9127Z",
    fill: "#494C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0234 77.6858V74.7347C97.0234 73.0973 98.3205 71.7541 99.957 71.697L100.762 71.6689H103.043L103.782 71.6952C105.44 71.754 106.773 73.0776 106.845 74.7347V77.6858L101.88 78.6484L97.0234 77.6858Z",
    fill: "#BBC3CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.78 71.4769V70.4717C100.78 70.3315 100.894 70.2178 101.034 70.2178H102.684C102.825 70.2178 102.938 70.3315 102.938 70.4717V71.4769C102.938 71.5252 102.952 71.5726 102.978 71.6133L103.298 72.1166C103.353 72.2032 103.383 72.3037 103.383 72.4064C103.383 72.5547 103.322 72.6964 103.214 72.7984L102.908 73.0878C102.352 73.6146 101.487 73.6342 100.908 73.133L100.516 72.7943C100.402 72.6955 100.336 72.5518 100.336 72.4007C100.336 72.3018 100.364 72.2048 100.417 72.1214L100.741 71.6133C100.766 71.5726 100.78 71.5252 100.78 71.4769Z",
    fill: "#A2ABB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.621 68.2718L104.439 68.6668C104.375 68.8054 104.256 68.9115 104.112 68.9598C104.013 68.9925 103.932 69.0638 103.888 69.1573L103.551 69.861C103.364 70.2519 103.031 70.5534 102.623 70.7002L102.515 70.7393C101.97 70.9353 101.375 70.9353 100.831 70.7393C100.366 70.572 100.018 70.1812 99.9046 69.7005L99.7136 68.8885C99.6241 68.5083 99.6099 68.1144 99.6716 67.7287L99.711 67.4823C99.791 66.9819 99.9597 66.4998 100.209 66.0587L100.558 65.4419C100.609 65.3511 100.731 65.3306 100.809 65.3996L101.696 66.182C101.722 66.2056 101.754 66.2234 101.788 66.234L102.752 66.5353L103.113 66.6874C103.63 66.9053 103.98 67.3975 104.015 67.958C104.017 67.9875 104.056 67.9963 104.07 67.9705L104.195 67.7452C104.261 67.6276 104.427 67.6208 104.502 67.7328L104.589 67.8636C104.67 67.9849 104.682 68.1395 104.621 68.2718Z",
    fill: "url(#paint2_linear_3752_75218)"
  })))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 33.1833,
    height: 1.58928,
    rx: 0.794642,
    transform: "matrix(1 -1.27572e-08 -5.19345e-06 1 74.5469 54.6191)",
    fill: "#83888E",
    fillOpacity: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 33.2143,
    height: 1.58928,
    rx: 0.794642,
    transform: "matrix(1 -1.95549e-08 -3.38809e-06 1 74.5469 58.0127)",
    fill: "#83888E",
    fillOpacity: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 15.5101,
    height: 1.58928,
    rx: 0.794642,
    transform: "matrix(1 -1.27572e-08 -5.19345e-06 1 92.2578 77.5)",
    fill: "#83888E",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0816 82.136C29.7165 80.8449 30.3907 78.0497 30.2313 76.0965C30.0962 74.44 28.9008 74.3028 27.4702 74.8041C25.2477 75.5828 22.8143 76.9166 22.3556 79.3803C22.0168 81.1998 21.772 84.237 24.1182 84.8214C26.1255 85.3214 27.649 82.5693 27.511 80.8587C27.44 79.979 26.268 80.3573 26.1355 81.0347C25.7712 82.8986 27.8833 83.8073 29.4774 83.5642C30.2838 83.4413 30.9005 82.9424 31.3725 82.3121C31.4686 82.1837 31.6634 81.5955 31.9023 81.7639C32.5642 82.2307 33.2636 82.5441 33.9501 82.9507",
    stroke: "#83888E",
    strokeOpacity: 0.8,
    strokeWidth: 0.738095,
    strokeLinecap: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 18.2034,
    height: 1.58928,
    rx: 0.794642,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 43.5469 52.7744)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 24.3683,
    height: 1.58928,
    rx: 0.794642,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 43.5469 61.2686)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 37.0603,
    height: 1.58928,
    rx: 0.794642,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 43.5469 74.7168)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 7.59096,
    height: 1.58928,
    rx: 0.794642,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 43.5469 56.168)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 13.7303,
    height: 1.58928,
    rx: 0.794642,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 43.5469 64.6621)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 37.473,
    height: 1.58928,
    rx: 0.794642,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 43.5469 78.1104)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.75 45.0239V40.7295H69.6437V41.4781H67.6579V42.5013H69.4948V43.2499H67.6579V44.2753H69.6521V45.0239H66.75Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7414 41.9647C64.7247 41.7955 64.6527 41.6641 64.5255 41.5705C64.3983 41.4768 64.2256 41.43 64.0075 41.43C63.8594 41.43 63.7343 41.4509 63.6322 41.4929C63.5302 41.5334 63.4519 41.59 63.3974 41.6627C63.3442 41.7354 63.3177 41.8179 63.3177 41.9101C63.3149 41.987 63.331 42.0541 63.3659 42.1114C63.4022 42.1688 63.4519 42.2184 63.5148 42.2603C63.5777 42.3009 63.6504 42.3365 63.7329 42.3673C63.8153 42.3966 63.9034 42.4218 63.9971 42.4427L64.3829 42.535C64.5702 42.5769 64.7421 42.6329 64.8987 42.7028C65.0553 42.7727 65.1909 42.8586 65.3055 42.9607C65.4201 43.0627 65.5089 43.1829 65.5718 43.3213C65.6361 43.4597 65.669 43.6184 65.6704 43.7973C65.669 44.0601 65.6019 44.288 65.4691 44.4809C65.3377 44.6724 65.1475 44.8213 64.8987 44.9275C64.6513 45.0324 64.3528 45.0848 64.0034 45.0848C63.6567 45.0848 63.3547 45.0317 63.0975 44.9254C62.8417 44.8192 62.6418 44.6619 62.4978 44.4536C62.3552 44.244 62.2804 43.9846 62.2734 43.6757H63.152C63.1618 43.8197 63.2031 43.9399 63.2757 44.0364C63.3498 44.1314 63.4484 44.2034 63.5714 44.2523C63.6958 44.2999 63.8363 44.3236 63.9929 44.3236C64.1466 44.3236 64.2801 44.3013 64.3934 44.2565C64.508 44.2118 64.5968 44.1496 64.6597 44.0699C64.7226 43.9902 64.754 43.8987 64.754 43.7952C64.754 43.6988 64.7254 43.6177 64.6681 43.552C64.6121 43.4863 64.5297 43.4304 64.4206 43.3842C64.313 43.3381 64.1809 43.2962 64.0243 43.2584L63.5567 43.141C63.1947 43.0529 62.9088 42.9152 62.6991 42.7279C62.4894 42.5406 62.3853 42.2883 62.3867 41.971C62.3853 41.7109 62.4545 41.4838 62.5943 41.2895C62.7354 41.0952 62.9291 40.9435 63.1751 40.8345C63.4211 40.7254 63.7007 40.6709 64.0138 40.6709C64.3326 40.6709 64.6107 40.7254 64.8484 40.8345C65.0874 40.9435 65.2733 41.0952 65.4062 41.2895C65.539 41.4838 65.6075 41.7088 65.6116 41.9647H64.7414Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1857 40.7295V45.0239H60.4014L58.5331 42.321H58.5017V45.0239H57.5938V40.7295H58.3906L60.2442 43.4302H60.2819V40.7295H61.1857Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5078 45.0239V40.7295H56.4015V41.4781H54.4158V42.5013H56.2526V43.2499H54.4158V44.2753H56.4099V45.0239H53.5078Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3801 42.2331H51.4617C51.4449 42.1142 51.4107 42.0087 51.359 41.9164C51.3072 41.8228 51.2408 41.7431 51.1598 41.6774C51.0787 41.6117 50.985 41.5614 50.8788 41.5264C50.7739 41.4915 50.66 41.474 50.537 41.474C50.3147 41.474 50.1211 41.5292 49.9562 41.6396C49.7912 41.7487 49.6633 41.908 49.5724 42.1177C49.4816 42.326 49.4361 42.579 49.4361 42.8768C49.4361 43.1829 49.4816 43.4402 49.5724 43.6484C49.6647 43.8567 49.7933 44.014 49.9583 44.1202C50.1232 44.2265 50.314 44.2796 50.5307 44.2796C50.6523 44.2796 50.7649 44.2635 50.8683 44.2314C50.9731 44.1992 51.0661 44.1524 51.1472 44.0909C51.2283 44.028 51.2954 43.9518 51.3485 43.8623C51.403 43.7729 51.4407 43.6708 51.4617 43.5562L52.3801 43.5604C52.3564 43.7575 52.297 43.9476 52.2019 44.1307C52.1082 44.3124 51.9817 44.4753 51.8224 44.6193C51.6644 44.7619 51.4757 44.8751 51.2562 44.959C51.0382 45.0415 50.7914 45.0827 50.516 45.0827C50.133 45.0827 49.7905 44.996 49.4886 44.8227C49.188 44.6493 48.9504 44.3984 48.7756 44.0699C48.6023 43.7414 48.5156 43.3437 48.5156 42.8768C48.5156 42.4085 48.6037 42.0101 48.7798 41.6816C48.956 41.3531 49.195 41.1029 49.497 40.9309C49.7989 40.7576 50.1386 40.6709 50.516 40.6709C50.7649 40.6709 50.9955 40.7058 51.208 40.7757C51.4219 40.8456 51.6113 40.9477 51.7762 41.0819C51.9412 41.2147 52.0754 41.3775 52.1788 41.5705C52.2837 41.7634 52.3508 41.9842 52.3801 42.2331Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3767 40.7295V45.0239H46.4688V40.7295H47.3767Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6406 45.0239V40.7295H43.5486V44.2753H45.3896V45.0239H42.6406Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4609 45.0239V40.7295H38.1552C38.4795 40.7295 38.7563 40.7875 38.9856 40.9035C39.2162 41.0182 39.3917 41.181 39.5119 41.3921C39.6335 41.6018 39.6943 41.8485 39.6943 42.1323C39.6943 42.4175 39.6328 42.6628 39.5098 42.8683C39.3868 43.0724 39.2085 43.229 38.9751 43.338C38.743 43.447 38.462 43.5015 38.1321 43.5015H36.9977V42.7718H37.9854C38.1587 42.7718 38.3027 42.7481 38.4173 42.7005C38.5319 42.653 38.6172 42.5817 38.6731 42.4867C38.7304 42.3916 38.7591 42.2735 38.7591 42.1323C38.7591 41.9897 38.7304 41.8695 38.6731 41.7716C38.6172 41.6738 38.5312 41.5997 38.4152 41.5494C38.3006 41.4976 38.1559 41.4718 37.9812 41.4718H37.3689V45.0239H36.4609ZM38.7801 43.0696L39.8474 45.0239H38.8451L37.8008 43.0696H38.7801Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3672 45.0239V40.7295H35.2609V41.4781H33.2751V42.5013H35.112V43.2499H33.2751V44.2753H35.2692V45.0239H32.3672Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2586 40.7295L29.2965 43.9922H29.3364L30.3764 40.7295H31.3829L29.9025 45.0239H28.7325L27.25 40.7295H28.2586Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2595 40.7295V45.0239H25.3516V40.7295H26.2595Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0078 45.0239V40.7295H22.7021C23.0264 40.7295 23.3032 40.7875 23.5324 40.9035C23.7631 41.0182 23.9385 41.181 24.0587 41.3921C24.1804 41.6018 24.2412 41.8485 24.2412 42.1323C24.2412 42.4175 24.1797 42.6628 24.0566 42.8683C23.9336 43.0724 23.7554 43.229 23.5219 43.338C23.2899 43.447 23.0089 43.5015 22.679 43.5015H21.5446V42.7718H22.5322C22.7056 42.7718 22.8496 42.7481 22.9642 42.7005C23.0788 42.653 23.1641 42.5817 23.22 42.4867C23.2773 42.3916 23.306 42.2735 23.306 42.1323C23.306 41.9897 23.2773 41.8695 23.22 41.7716C23.1641 41.6738 23.0781 41.5997 22.9621 41.5494C22.8475 41.4976 22.7028 41.4718 22.528 41.4718H21.9158V45.0239H21.0078ZM23.3269 43.0696L24.3942 45.0239H23.3919L22.3477 43.0696H23.3269Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7567 45.0239H16.2344V40.7295H17.7693C18.2012 40.7295 18.5731 40.8155 18.8848 40.9874C19.1965 41.158 19.4363 41.4033 19.604 41.7234C19.7732 42.0435 19.8578 42.4266 19.8578 42.8725C19.8578 43.3198 19.7732 43.7042 19.604 44.0258C19.4363 44.3473 19.1951 44.594 18.8806 44.766C18.5675 44.9379 18.1928 45.0239 17.7567 45.0239ZM17.1423 44.2459H17.719C17.9874 44.2459 18.2131 44.1984 18.3962 44.1033C18.5808 44.0069 18.7192 43.858 18.8114 43.6567C18.9051 43.454 18.9519 43.1926 18.9519 42.8725C18.9519 42.5552 18.9051 42.2958 18.8114 42.0945C18.7192 41.8933 18.5815 41.7451 18.3983 41.65C18.2152 41.555 17.9894 41.5074 17.7211 41.5074H17.1423V44.2459Z",
    fill: "black",
    fillOpacity: 0.6
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97266 109.895H13.3721V110.962H5.90625V103.496H6.97266V109.895ZM117.358 110.962H109.893V109.895H116.292V103.496H117.358V110.962ZM13.3721 14.4404H6.97266V20.8398H5.90625V13.374H13.3721V14.4404ZM117.358 20.8398H116.292V14.4404H109.893V13.374H117.358V20.8398Z",
    fill: "#1FACB1"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 70.8601,
    y: 88.5711,
    width: 35.4282,
    height: 35.4282
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.48px)",
      clipPath: "url(#bgblur_1_3752_75218_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 2.95238,
    x: 73.8125,
    y: 91.5234,
    width: 29.5238,
    height: 29.5238,
    rx: 14.7619,
    fill: "#9AE5E7",
    fillOpacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.5751,
    cy: 106.285,
    r: 11.8095,
    fill: "#04BEC4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4541 103.112C94.6944 103.879 93.9375 104.629 93.1779 105.375C91.4546 107.069 89.731 108.763 88.0043 110.454C87.8063 110.648 87.5846 110.795 87.2929 110.859C86.8539 110.955 86.4838 110.835 86.1881 110.549C84.8611 109.265 83.548 107.968 82.234 106.671C81.933 106.375 81.8375 105.793 82.0282 105.401C82.2359 104.975 82.5688 104.731 83.0742 104.706C83.5115 104.685 83.8426 104.865 84.1324 105.148C85.105 106.097 86.0727 107.052 87.0457 108.008C89.2507 105.842 91.4519 103.676 93.6567 101.514C94.1691 101.012 94.8832 100.976 95.4189 101.471C95.8606 101.878 95.9138 102.654 95.4541 103.112Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.1
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M102.597 37.6426C105.45 37.6428 107.763 39.9562 107.763 42.8096C107.763 45.6628 105.45 47.9754 102.597 47.9756C101.804 47.9756 101.053 47.7957 100.382 47.4766C101.024 47.1716 101.592 46.7386 102.055 46.21C102.231 46.2379 102.412 46.2539 102.597 46.2539C104.499 46.2537 106.041 44.7116 106.041 42.8096C106.041 40.9074 104.499 39.3654 102.597 39.3652C102.412 39.3652 102.231 39.3803 102.055 39.4082C101.592 38.8795 101.024 38.4456 100.382 38.1406C101.053 37.8216 101.804 37.6426 102.597 37.6426ZM98.709 39.4082C99.3399 39.5078 99.9139 39.7779 100.382 40.1709C99.6299 40.8027 99.1523 41.7505 99.1523 42.8096C99.1524 43.8681 99.6305 44.8144 100.382 45.4463C99.9138 45.8397 99.3402 46.1103 98.709 46.21C97.9133 45.3013 97.4298 44.1123 97.4297 42.8096C97.4297 41.5066 97.9131 40.3171 98.709 39.4082Z",
    fill: "black",
    fillOpacity: 0.6
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3752_75218",
    x: -16.7725,
    y: 13.3971,
    width: 149.794,
    height: 101.077,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.87152,
    dy: 1.93576
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.6146
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.239216 0 0 0 0 0.392157 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3752_75218"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3752_75218",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_3752_75218_clip_path",
    transform: "translate(-70.8601 -88.5711)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.8125,
    y: 91.5234,
    width: 29.5238,
    height: 29.5238,
    rx: 14.7619
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3752_75218",
    x1: 12.4911,
    y1: 63.0736,
    x2: 145.541,
    y2: 52.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9D1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607628,
    stopColor: "#DAE2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3752_75218",
    x1: 25.6623,
    y1: 59.6186,
    x2: 30.5916,
    y2: 67.7367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABB4BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3752_75218",
    x1: 100.663,
    y1: 66.1599,
    x2: 103.128,
    y2: 70.2189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABB4BE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3752_75218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriversLicenseFrontOk);
export default __webpack_public_path__ + "static/media/DriversLicenseFrontOk.f3762424925ead844548359075315945.svg";
export { ForwardRef as ReactComponent };